<template>
    <div class="corporateInformation-wrapper">
        <h2 class="page-title">{{ $t('changePassword') }}</h2>
		<el-divider></el-divider>
        <template v-if="root_management === '1'">
            <el-row :gutter="12">
                <el-col :xs="24" :span="10" :lg="8">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{$t('changePassword')}}</span>
                        </div>
                        <el-form :model="form">
                            <el-form-item :label="item.label" v-for="item in formConfig" :key="item.prop">
                                <el-input v-model="form[item.prop]" clearable type="password" show-password></el-input>
                            </el-form-item>
                        </el-form>
                        <el-button type="primary" @click="changeInfo" class="btn">{{$t('submit')}}</el-button>
                    </el-card>
                </el-col>
            </el-row>
        </template>
        <template v-if="root_management === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>
    </div>
</template>
<script>
import {updatePassword} from '@/api'
export default {
    data() {
        return {
            root_management: '0',
			store_management: '0',
			exportcsv: '0',
			qyid: '',
            storeid:'',
            formConfig: [
                {label: this.$t('OldPassword'), prop: 'password', type: 'input'},
                {label: this.$t('NewPassword'), prop: 'newpwd', type: 'input'},
            ],
            form: {
                password: '',
                newpwd: '',
            },
        }
    },
    created() {
        var user = JSON.parse(window.localStorage.getItem('user'))
        this.form.username = user.username

        var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        this.qyid = auser.qyid
        this.storeid = auser.storeid
        this.root_management = auser.root_management
        this.store_management = auser.store_management
        this.exportcsv = auser.exportcsv
    },
    methods: {
        changeInfo() {
            if(this.form.password && this.form.newpwd) {
                console.log("update pwwwwwwwwwwwwwww")
                updatePassword(this.form)
                    .then(res=>{
                        console.log("update pwwwwwwwwwwwwwww2")
                        console.log(res)
                        if(res.code == '1'){
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            })
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            })
                        }
                    })
                    .catch(_ => {
                        console.log("update pwwwwwwwwwwwwwww3")
                    })
            } else {
                console.log("update pwwwwwwwwwwwwwww4")
                this.$message({
                    message: this.$t('pleaseFillInTheInformation'),
                    type: 'warning'
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.corporateInformation-wrapper {
    .btn{
        width: 80%;
        display: block;
        margin: 0 auto;
    }
}
</style>